import { baseAPIRequest } from 'utilities/http';

async function getPostalCode () {

	try {

		const response = await baseAPIRequest({
			url: `/api/product-shipping/postal-code/`,
			params: {
				method: 'GET'
			}
		});
		return response;

	} catch (error) {

		console.log(error);

	}

}

export default getPostalCode;
